import { CourseSearchParams } from "@/types/klass";

// MARK: 강의 검색 관련 쿼리 키
export const klassKeys = {
  all: ["klass"] as const,
  search: (params: CourseSearchParams) => ["/class/public/courses/search", params],
  free: () => ["/class/public/courses/search", { free: true }],
  relatedContents: (params: { productId: string; contentType: "CLASS" | "SEMINAR" }) => [
    "/market/products",
    params.productId,
    "related-contents",
    params.contentType,
  ],
  product: (params: { productId: string }) => ["/class/public/courses/product", params.productId],
  relatedProducts: (productIds: string[]) => [
    "/class/public/courses/product",
    "related",
    productIds,
  ],
};
